import { Banner, type BannerColors } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useCheckoutMessage } from '@/scopes/checkout/domain/hooks'
import { bannerColorMap } from '@/scopes/checkout/domain/types'
import { BannerType } from '@/scopes/common/domain/types/banner'

export function CheckoutMessage(props: { componentId: string }) {
  const { componentId } = props
  const { message } = useCheckoutMessage(componentId)

  if (!message)
    return null

  const { banners } = message
  if (!banners.length) {
    return null
  }

  return (
    <>
      {banners.map(
        ({ title, text, type = 'info' }: { title?: string, text?: string, type?: string }, index: number) => (
          <Banner
            key={`banner-${index}`}
            color={bannerColorMap[type as BannerType] as BannerColors}
            size="M"
            hasIcon
            contentIsCentered={!(title && text)}
          >
            <Banner.TextsWrapper>
              {title && <Banner.Text>{title}</Banner.Text>}
              {text && <Banner.SupportingText innerHTML={text} />}
            </Banner.TextsWrapper>
          </Banner>
        ),
      )}
    </>
  )
}
